import { Injectable, signal, Signal } from "@angular/core";
import GeobusNavigationExtension from "./geobus-navigation.extension";
import { IType } from "@geolib/geoappbase-client";


@Injectable({ providedIn: "root" })
export default class GeobusUserAdministrationExtension extends GeobusNavigationExtension {

    public get component(): IType<unknown> | null {
        return null;
    }

    public get identifier(): string | null {
        return "GeobusUserAdministrationExtensionName";
    }

    public get title(): Signal<string> {
        return signal("SIDE_MENU.USER_ORGANISATION.USER_ADMIN").asReadonly();
    }

    public get category(): string {
        return "user_and_organisation";
    }

    public get state(): { name: string } {
        return { name: "app.users" };
    }

    public get icon(): string {
        return "user";
    }

}
